export default (items, sortKey = "created_at") => {
  if (!items) return null;
  return items.sort((a, b) => new Date(b[sortKey]) - new Date(a[sortKey]));
};
